import { render, staticRenderFns } from "./FeatureManage.vue?vue&type=template&id=72a275e2&"
import script from "./FeatureManage.vue?vue&type=script&lang=js&"
export * from "./FeatureManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports